var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._l((_vm.list),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{path:item.path}}},[_vm._v(_vm._s(item.name))])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }